"use client";
import * as React from "react";
const SvgFileUploadFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 14 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M4.21 12.24H9.8V6.58h3.71L7 0 .5 6.59h3.71zM.5 14.11h13V16H.5z" }));
export {
  SvgFileUploadFilled as default
};
